(function () {
  function updateButtons(sectionId, isPreorder, label) {
    var mainBtn = document.getElementById('ProductSubmitButton-' + sectionId);
    if (mainBtn && isPreorder) {
      mainBtn.removeAttribute('disabled');
      var mainSpan = mainBtn.querySelector('span');
      if (mainSpan && label) mainSpan.textContent = label;
    }

    document
      .querySelectorAll('[data-pm-preorder-cta="' + sectionId + '"]')
      .forEach(function (cta) {
        var span = cta.querySelector('span');
        if (!span) return;
        if (isPreorder) {
          cta.removeAttribute('disabled');
          if (label) span.textContent = label;
        } else if (cta.dataset.defaultLabel) {
          span.textContent = cta.dataset.defaultLabel;
        }
      });
  }

  function applyFromElement(el, sectionId) {
    if (!el) return;
    var isPreorder = el.getAttribute('data-preorder') === 'true';
    var label = el.getAttribute('data-btn-label') || '';
    updateButtons(sectionId, isPreorder, label);
  }

  if (typeof subscribe === 'function') {
    subscribe('variant-change', function (event) {
      if (!event || !event.data) return;
      var sectionId = event.data.sectionId;
      if (!sectionId) return;

      var dest = document.getElementById('PreOrder-' + sectionId);
      var src = event.data.html
        ? event.data.html.getElementById('PreOrder-' + sectionId)
        : null;

      if (src && dest) {
        dest.innerHTML = src.innerHTML;
        dest.setAttribute('data-preorder', src.getAttribute('data-preorder'));
        dest.setAttribute('data-btn-label', src.getAttribute('data-btn-label') || '');
        dest.hidden = src.getAttribute('data-preorder') !== 'true';
      }

      // InVogue (Oct 2026): the lower "$price - Add to cart" buttons (snippets/product-cta-buttons)
      // kept the price of the variant the page loaded with, because their data-default-label
      // was only ever set at render. Refresh label + sold-out state from the re-rendered
      // section for the newly selected variant, so they always match the main selector.
      if (event.data.html) {
        var freshCtas = event.data.html.querySelectorAll('[data-pm-preorder-cta="' + sectionId + '"]');
        document.querySelectorAll('[data-pm-preorder-cta="' + sectionId + '"]').forEach(function (cta, i) {
          var fresh = freshCtas[i] || freshCtas[0];
          if (!fresh) return;
          var freshSpan = fresh.querySelector('span');
          // Sold-out/unavailable variants: keep the server's "Sold out" wording, not the price label.
          if (fresh.hasAttribute('disabled') && freshSpan) cta.dataset.defaultLabel = freshSpan.textContent.trim();
          else if (fresh.dataset.defaultLabel) cta.dataset.defaultLabel = fresh.dataset.defaultLabel;
          var span = cta.querySelector('span');
          if (freshSpan && span) span.textContent = freshSpan.textContent;
          if (fresh.hasAttribute('disabled')) cta.setAttribute('disabled', '');
          else cta.removeAttribute('disabled');
        });
      }

      applyFromElement(dest || src, sectionId);

      // Pickup-required notice (variant-level metafield)
      var puDest = document.getElementById('PickupNotice-' + sectionId);
      var puSrc = event.data.html
        ? event.data.html.getElementById('PickupNotice-' + sectionId)
        : null;
      if (puSrc && puDest) {
        puDest.innerHTML = puSrc.innerHTML;
        puDest.hidden = puSrc.hasAttribute('hidden');
      }
    });
  }

  function initSticky(wrap) {
    var targetId = wrap.dataset.target || '';
    var target = document.getElementById(targetId);
    var btn = wrap.querySelector('[data-pm-sticky-buy-btn]');

    // Move the fixed button to <body> so it is always positioned relative to the
    // viewport, regardless of any transformed ancestor sections.
    if (wrap.parentNode !== document.body) {
      document.body.appendChild(wrap);
    }

    if (btn && target) {
      btn.addEventListener('click', function () {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    if (!target) return;

    var ticking = false;
    function check() {
      ticking = false;
      var rect = target.getBoundingClientRect();
      // Show once the <product-info> block has scrolled above the viewport.
      var passed = rect.bottom <= 0;
      wrap.classList.toggle('is-visible', passed);
    }
    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(check);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    check();
  }

  function run() {
    document.querySelectorAll('[data-pm-sticky-buy]').forEach(initSticky);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
